/* global dataLayer */

import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';
import jump from 'jump.js';

class OrderFormController extends Controller {
  connect() {
    this.API_URL = this.data.get('api');
    this.TYPE = this.data.get('type');
    this.MOBILE_CART_BUTTON = document.querySelector('.js-mobile-cart-button');
    this.MOBILE_QUOTATION_BUTTON = document.querySelector('.js-mobile-quotation-button');
    this.CART_COUNT_ELEMENTS = document.querySelectorAll('[data-cart-count]');
    this.QUOTATION_COUNT_ELEMENTS = document.querySelectorAll('[data-quotation-count]');
    this.RELATED_CART_PRODUCTS_MODAL = $('.js-related-cart-products-modal');
  }

  onSubmit(event) {
    event.preventDefault();

    const id = this.data.get('variant-id');
    const price = this.data.get('price');
    const quantity = parseInt(this.quantityTarget.value, 10);
    const palletType = this.hasPalletTypeTarget ? this.palletTypeTarget.value : null;

    if (this.isInvalid(quantity)) return;

    if (this.TYPE === 'quotation') {
      OrderFormController.addToQuotation(id, quantity, this.API_URL, palletType).then((res) => {
        jump('body', {
          a11y: true,
          offset: 0,
          duration: 500,
          callback: () => {
            setTimeout(() => {
              this.updateHeaderQuotation(res.quotation, res.count);
              this.updateQuotationCounts(res.count);
              this.updateQuotationButtonVisibility();

              if (this.data.has('reload') && this.data.get('reload')) {
                window.location.reload();
              }
            }, 250);
          },
        });
      });
    } else {
      OrderFormController.addToCart(id, quantity, this.API_URL, palletType).then((res) => {
        jump('body', {
          a11y: true,
          offset: 0,
          duration: 500,
          callback: () => {
            setTimeout(() => {
              this.updateHeaderCart(res.cart, res.count);
              this.updateCartCounts(res.count);
              this.updateCartButtonVisibility();

              if (this.data.has('reload') && this.data.get('reload')) {
                window.location.reload();
              }
            }, 250);
          },
        });
      });

      this.showRelatedProductsModal();
    }

    this.sendToGTM(id, price);
  }

  isInvalid(quantity) {
    const min = parseInt(this.data.get('min'), 10);
    const max = parseInt(this.data.get('max'), 10);

    if (Number.isNaN(quantity)) {
      return true;
    }

    if (quantity < min) {
      return true;
    }

    if (quantity > max) {
      return true;
    }

    return false;
  }

  // eslint-disable-next-line
  sendToGTM(id, price) {
    if (typeof dataLayer === 'undefined') return;

    dataLayer.push({
      event: this.TYPE === 'quotation' ? 'add_to_quotation' : 'add_to_cart',
      conversion_value: price || 0,
      product_id: id,
    });
  }

  updateHeaderCart(html, count) {
    const headerCartControllerEl = document.querySelector('[data-controller*="header-cart"]');
    const headerCartController = this.application.getControllerForElementAndIdentifier(
      headerCartControllerEl,
      'header-cart',
    );

    headerCartController.updateHeaderCart(html, count);
  }

  updateHeaderQuotation(html, count) {
    const headerQuotationControllerEl = document.querySelector('[data-controller*="header-quotation"]');
    const headerQuotationController = this.application.getControllerForElementAndIdentifier(
      headerQuotationControllerEl,
      'header-quotation',
    );

    headerQuotationController.updateHeaderQuotation(html, count);
  }

  updateCartCounts(count) {
    toArray(this.CART_COUNT_ELEMENTS).forEach((el) => { el.innerText = count; });
  }

  updateQuotationCounts(count) {
    toArray(this.QUOTATION_COUNT_ELEMENTS).forEach((el) => { el.innerText = count; });
  }

  updateCartButtonVisibility() {
    if (!this.MOBILE_CART_BUTTON) return;

    this.MOBILE_CART_BUTTON.hidden = false;
  }

  updateQuotationButtonVisibility() {
    if (!this.MOBILE_QUOTATION_BUTTON) return;

    this.MOBILE_QUOTATION_BUTTON.hidden = false;
  }

  showRelatedProductsModal() {
    if (!this.RELATED_CART_PRODUCTS_MODAL.get(0)) return;

    this.RELATED_CART_PRODUCTS_MODAL.modal('show');
  }

  static addToCart(id, quantity, api, palletType = null) {
    return $.ajax({
      url: api,
      type: 'POST',
      data: {
        product_variant_id: id,
        quantity,
        pallet_type: palletType,
      },
    });
  }

  static addToQuotation(id, quantity, api, palletType = null) {
    return $.ajax({
      url: api,
      type: 'POST',
      data: {
        product_variant_id: id,
        quantity,
        pallet_type: palletType,
      },
    });
  }
}

OrderFormController.targets = [
  'quantity',
  'palletType',
];

export default OrderFormController;
